import { useEffect } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { apiFetch } from "../api/client";
import { useWorkspace } from "../contexts/WorkspaceContext";

export function AppShell() {
  const { setWorkspaces, setActiveWorkspace } = useWorkspace();

  useEffect(() => {
    apiFetch("/workspaces")
      .then(async (res) => {
        if (res.ok) {
          setActiveWorkspace(null);
          setWorkspaces(await res.json());
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="flex h-screen bg-canvas text-ink overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
